<!-- src/App.vue -->

<template>
  <main>
    <div class="container mx-auto" data-aos="fade-right">
      <div class="row justify-content-center mt-3 m-2">
        <div class="col-12 col-lg-6 dark-gray-box-1 py-2 mb-3 mb-lg-0">
        <h6 class="subTitleFont">Recent Chapters</h6>
        <ChapterList size="compact" :limit="3" />
        </div>
        <div class="col-12 col-lg-5 dark-gray-box-1 py-2 ms-lg-3">
          <h6 class="subTitleFont">News</h6>
          <p class="p-2 textlightgray">Check back later!</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  //import imageBlock from './../../components/imageBlock.vue';
  import ChapterList from '@/ChapterList.vue';
  import 'animate.css';
  
  export default {
    name: 'HomePage',
    components: {
    //imageBlock,
    ChapterList,
   
    },
    // Hide the data until user selects it
    data() {
      return {
        showApp: true,
        showB1:  false,
        showB2:  false,
        showB3:  false,
        showB4:  false,
        showB5:  false,
        isClassAdded: false,
        apiUrl: '',
      };
    },
    methods: {
      toggle(property) {
        console.log('Toggling', property);
        this[property] = !this[property];
      },
      addClass(event) {
      // Prevent the default navigation
      event.preventDefault();

      // Add the class to trigger the animation
      this.isClassAdded = true;

      // Wait for the animation to complete before navigating
      // Assuming the animation duration is 1 second (1000 milliseconds)
      setTimeout(() => {
        window.location.href = this.apiUrl;
      }, 1000); // Adjust the timeout duration based on your actual animation duration
    },
    },
    mounted(){
      document.title = "Dissentia Home";
    },
    created() {
      const userAgent = navigator.userAgent;
      if (process.env.NODE_ENV === 'production' || (/Mobi|Android/i.test(userAgent))) {
        this.apiUrl = 'https://read1.sinlessofdissentia.com/subTitleFont';
      } else {
        this.apiUrl = 'http://localhost:8080/subTitleFont';
      }

  },
  }

</script>